module.exports = __webpack_public_path__ + "media/images/lb/363-74a1bee7228e78390c040bdbe8ddfd96.svg";